export interface AnalyticsUser {
  id?: string
  email?: string
  username?: string
  nickname?: string
}

export interface UserPersonProperties {
  email?: string
  username?: string
  name?: string
}

export function buildUserPersonProperties(user: AnalyticsUser): UserPersonProperties {
  return {
    email: user.email,
    username: user.username,
    name: user.nickname || user.username,
  }
}
